import React, { Component, forwardRef } from "react"
import Svg from "../_svgs/svg"
import * as endpoints from "../../api/endpoints"
import FlightsTable from "./flights-table"
import NoFlights from "./no-flights"
import * as dateHelper from "../../booking/helpers/date"
import Spinner from "../../booking/components/spinner"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import DatePicker from "react-datepicker"
import { isMobile } from "react-device-detect"
import * as types from "./page-types"
import { DateTime } from "luxon"
import FlightsLoading from "./flights-loading"

export default class ArrivalsDeparturesListSearch extends Component {
  constructor(props) {
    super(props)
    this.datePicker = undefined

    const dtLocale = dateHelper.luxonLocale(props.language)
    const zone = "Europe/Copenhagen"
    const cphTimeConvert = DateTime.local().setLocale(dtLocale).setZone(zone) // gets local time and changes timezone to copenhagen to get correct time
    const cphTime = cphTimeConvert.setZone("local", { keepLocalTime: true }) // locks in copenhagen time and switches back to local timezone. This ensures the time will stay CPH time when we later converts the DateTime to a JS Date object.
    let startDate = cphTime.set({ milliseconds: 0, seconds: 0, minutes: 60 }).minus({ hours: 1 })
    let minDate = startDate.minus({ days: 1 })
    let minTime = cphTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    let maxTime = cphTime.set({ hours: 23, minutes: 0, seconds: 0, milliseconds: 0 })

    this.state = {
      q: props.query || "",
      previousFlights: [],
      flights: null,
      direction: "D",
      pageType: types.DEPARTURES,
      ajaxSpinnerActive: true,
      ajaxSpinnerTransparent: false,
      initialSearch: props.query ? true : false,
      searchDate: startDate,
      minDate: minDate,
      datepickerOpen: false,
      minTime: minTime,
      maxTime: maxTime,
      otherDaysMinTime: minTime,
      currentUrl: this.props.departuresPage,
      startDate: startDate,
    }

    this.search("D", props.query ? `"${props.query}"` : "", startDate, props.language)
  }

  flightFilter = (flight, beforeDate) => {
    const date = flight.Date
    const time = flight.ExpectedTime
    const dateTime = DateTime.fromFormat(`${date} ${time}`, "dd-MM-yyyy HH:mm")
    if (dateTime < beforeDate) {
      return true
    }
    return false
  }

  search = async (direction, query, datetime, language) => {
    const userQuery = query && query.length >= 2 ? query : "*:*"
    const dt = datetime < this.state.startDate ? this.state.startDate : datetime
    const zone = "Europe/Copenhagen"
    const cphTime = dt.setZone(zone, { keepLocalTime: true }) // set zone to copenhagen and keep local time, which is already cph time
    const start = cphTime.minus({ days: 1 }).toUTC() // convert to UTC which is what Solr expects
    const end = cphTime.plus({ days: 2 }).toUTC() // convert to UTC which is what Solr expects
    const data = { direction: direction, query: userQuery ?? "", startDateTime: start, endDateTime: end, language: language }

    const response = await endpoints.getFlightInfoTable(data)
    let flights = []
    let previousFlights = []
    if (response?.data) {
      flights = response.data
    }
    if (flights.length > 0) {
      if (this.state.minDate < datetime) {
        const filteredFlights = flights.filter((flight) => this.flightFilter(flight, this.state.searchDate))
        const remainingFlights = flights.filter((flight) => !this.flightFilter(flight, this.state.searchDate))

        previousFlights = filteredFlights
        flights = remainingFlights
      }
      flights = flights?.filter((flight) => {
        const beforeDate = this.state.searchDate.plus({ days: 2 })
        return this.flightFilter(flight, beforeDate)
      })
    }
    this.setState({ flights: flights, previousFlights: previousFlights, ajaxSpinnerActive: false })
  }

  switchTabs(type) {
    if (type !== this.state.pageType) {
      this.setState(
        (prevState) => {
          switch (type) {
            case types.DEPARTURES:
              return this.getTabSwitchData(type)
            case types.ARRIVALS:
              return this.getTabSwitchData(type)
          }
        },
        () => {
          this.search(this.state.direction, this.state.initialSearch ? `"${this.state.q}"` : this.state.q, this.state.searchDate, this.props.language)
        },
      )
    }
  }

  getTabSwitchData(type) {
    return {
      ajaxSpinnerActive: true,
      pageType: type,
      direction: type === types.ARRIVALS ? "A" : "D",
      currentUrl: this.getCurrentUrl(type),
    }
  }

  getCurrentUrl(type) {
    switch (type) {
      case types.DEPARTURES:
        return this.props.departuresPage
      case types.ARRIVALS:
        return this.props.arrivalsPage
    }
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    this.setState(
      {
        [name]: value,
        initialSearch: false,
      },
      () => this.search(this.state.direction, this.state.q, this.state.searchDate, this.props.language),
    )
  }

  handleDateChange = (dateInput) => {
    this.setState(
      (prevState) => {
        const date = DateTime.fromJSDate(dateInput)
        const startOfMinDate = prevState.minDate.startOf("day")
        const startOfNewDate = date.startOf("day")
        if (startOfMinDate.toMillis() === startOfNewDate.toMillis()) {
          if (date <= prevState.minDate) {
            return { searchDate: prevState.minDate, minTime: prevState.minDate }
          }
          return { searchDate: date, minTime: prevState.minDate }
        } else {
          return { searchDate: date, minTime: prevState.otherDaysMinTime }
        }
      },
      () => {
        this.search(this.state.direction, this.state.q, this.state.searchDate, this.props.language)
      },
    )
  }

  handleDatepicker = () => {
    const openState = this.calendar.state.open
    this.calendar.setOpen(!openState)
    this.setState({ datepickerOpen: !this.state.datepickerOpen })
  }

  closeDatepicker = () => {
    this.setState({ datepickerOpen: false })
  }

  handleOutsideClick = () => {
    this.calendar.setOpen(false)
    this.setState({ datepickerOpen: false })
  }

  handlePrevDate = () => {
    const currentDate = this.state.searchDate
    let newDate = currentDate.minus({ days: 1 })
    if (newDate <= this.state.minDate) {
      newDate = this.state.minDate
    }
    this.handleDateChange(newDate.toJSDate())
  }

  handleNextDate = () => {
    const currentDate = this.state.searchDate
    const newDate = currentDate.plus({ days: 1 })
    this.handleDateChange(newDate.toJSDate())
  }

  scrollIntoView = () => {
    const flightSection = document.getElementById("FlightSection")
    const siteHeader = document.getElementsByClassName("site-header")[0]
    const headerOffset = siteHeader.clientHeight
    const elementPosition = flightSection.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  render() {
    const CustomInput = forwardRef(({ value }, ref) => (
      <div className={"react-datepicker-ignore-onclickoutside"} onClick={this.handleDatepicker} ref={ref}>
        {value}
      </div>
    ))
    CustomInput.displayName = "CustomInput"

    const departuresTabIcon = <Svg iconName={this.props.departuresTabIcon ? this.props.departuresTabIcon : "planetakeoff"} />
    const arrivalsTabIcon = <Svg iconName={this.props.arrivalsTabIcon ? this.props.arrivalsTabIcon : "planelanding"} />

    return (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
        <section className="deck deck--margin-bottom deck-flights">
          <div className="flights" id="FlightSection">
            <header id="flightHeader" className="flights__header no-bg">
              <React.Fragment>
                <div className="form flights__header__form">
                  <div className="w--wider flights__header__form__inner-wrapper">
                    <div className="form__section">
                      <div className="form__section__inner">
                        <div className="form__field form__field--text form__field--text-search  form__field--text--no-label">
                          <span className="form__valid"></span>
                          <input
                            className="form__item"
                            name="q"
                            id="searchTextbox"
                            type="text"
                            autoComplete="off"
                            value={this.state.q}
                            onChange={(e) => this.handleInput(e)}
                            placeholder={this.props.queryPlaceholderText}
                          />
                          <button data-arrival-departures-search-button="data-arrival-departures-search-button">
                            <Svg iconName={"search"} />
                          </button>
                        </div>
                      </div>
                    </div>
                    {!isMobile ? (
                      <div className={`dateselect ${this.state.datepickerOpen ? "datepicker-open" : ""}`}>
                        <DatePicker
                          ref={(r) => (this.calendar = r)}
                          selected={this.state.searchDate.toJSDate()}
                          onChange={(date) => this.handleDateChange(date)}
                          showTimeSelect={true}
                          dateFormat="dd. MMM yyyy"
                          minDate={this.state.minDate.toJSDate()}
                          minTime={this.state.minTime.toJSDate()}
                          maxTime={this.state.maxTime.toJSDate()}
                          locale={this.props.language === "en" ? enGB : da}
                          customInput={<CustomInput calendar={this.calendar} />}
                          timeCaption={this.props.datepickerTimeLabel || "Tidspunkt"}
                          timeIntervals={60}
                          onClickOutside={this.handleOutsideClick}
                          onCalendarClose={this.closeDatepicker}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </React.Fragment>
              <div className="tab-panes">
                <nav className="tab-panes__arrivals-departures">
                  <div className="tab-panes__arrivals-departures__primary">
                    <div className="tab-panes__arrivals-departures__primary__inner">
                      <a
                        className={`button button--toggle ${this.state.pageType === types.DEPARTURES ? "is-active" : ""}`}
                        onClick={() => this.switchTabs(types.DEPARTURES)}
                      >
                        {departuresTabIcon}
                        <span className="text">{this.props.departureTabName}</span>
                      </a>
                      <a
                        className={`button button--toggle ${this.state.pageType === types.ARRIVALS ? "is-active" : ""}`}
                        onClick={() => this.switchTabs(types.ARRIVALS)}
                      >
                        {arrivalsTabIcon}
                        <span className="text">{this.props.arrivalTabName}</span>
                      </a>
                    </div>
                  </div>
                </nav>
              </div>
            </header>
            {isMobile ? (
              <div className="mobile-datepicker-container">
                <div className="mobile-datepicker">
                  <div
                    className={`date-arrow prev-date ${
                      this.state.minDate.startOf("day").toMillis() === this.state.searchDate.startOf("day").toMillis() ? "arrow-disabled" : ""
                    }`}
                    onClick={
                      this.state.minDate.startOf("day").toMillis() === this.state.searchDate.startOf("day").toMillis()
                        ? undefined
                        : () => this.handlePrevDate()
                    }
                  ></div>
                  <div className={`dateselect ${this.state.datepickerOpen ? "datepicker-open" : ""}`}>
                    <DatePicker
                      ref={(r) => (this.calendar = r)}
                      selected={this.state.searchDate.toJSDate()}
                      onChange={(date) => this.handleDateChange(date)}
                      showTimeSelect={true}
                      dateFormat="d. MMMM"
                      minDate={this.state.minDate.toJSDate()}
                      minTime={this.state.minTime.toJSDate()}
                      maxTime={this.state.maxTime.toJSDate()}
                      locale={this.props.language === "en" ? enGB : da}
                      customInput={<CustomInput calendar={this.calendar} />}
                      timeCaption={this.props.datepickerTimeLabel || "Tidspunkt"}
                      timeIntervals={60}
                      onClickOutside={this.handleOutsideClick}
                      onCalendarClose={this.closeDatepicker}
                    />
                  </div>
                  <div className="date-arrow next-date" onClick={() => this.handleNextDate()}></div>
                </div>
              </div>
            ) : (
              ""
            )}
            {this.state.flights && this.state.flights.length > 0 ? (
              <FlightsTable
                {...this.props}
                language={this.props.language}
                flightLandingPageExists={this.props.flightLandingPageExists}
                currentUrl={this.state.currentUrl}
                flights={this.state.flights}
                previousFlights={this.state.previousFlights}
                direction={this.state.direction}
                scrollIntoView={this.scrollIntoView}
              />
            ) : !this.state.flights ? (
              <FlightsLoading />
            ) : (
              <NoFlights
                {...this.props}
                flightLandingPageExists={this.props.flightLandingPageExists}
                currentUrl={this.state.currentUrl}
                flights={this.state.flights}
                direction={this.state.direction}
              />
            )}
          </div>
        </section>
      </React.Fragment>
    )
  }
}
